// removed by extract-text-webpack-plugin
module.exports = {"new_left":"_3fICa2jqQzZojMFpzMubh6","m_title":"_15NUyz9yxJxSVb3VzuMLtu","m_ul":"_1JeIfep0uhXn8B86Yfp8D7","active":"_1nwJ_HYvlcPImbeLlqUwBU","new_right":"_3rbnneqxWZJVJ9jUERoKlr","new_right_wx":"_3NcBFak5C4D_Z8eLpZwWOd"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NewMedium/NewMedium.scss
 ** module id = 1076
 ** module chunks = 0
 **/